// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M6 14Q5.18 14 4.59 13.41T4 12 4.59 10.59 6 10 7.41 10.59 8 12 7.41 13.41 6 14M12 14Q11.18 14 10.59 13.41T10 12 10.59 10.59 12 10 13.41 10.59 14 12 13.41 13.41 12 14M18 14Q17.18 14 16.59 13.41T16 12 16.59 10.59 18 10 19.41 10.59 20 12 19.41 13.41 18 14"/>';

/** More (navigation). */
const icon: IconData = {
  id: "more",
  name: "More",
  category: "navigation",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M6 14Q5.18 14 4.59 13.41T4 12 4.59 10.59 6 10 7.41 10.59 8 12 7.41 13.41 6 14M12 14Q11.18 14 10.59 13.41T10 12 10.59 10.59 12 10 13.41 10.59 14 12 13.41 13.41 12 14M18 14Q17.18 14 16.59 13.41T16 12 16.59 10.59 18 10 19.41 10.59 20 12 19.41 13.41 18 14"/></g><path d="M6 14Q5.18 14 4.59 13.41T4 12 4.59 10.59 6 10 7.41 10.59 8 12 7.41 13.41 6 14M12 14Q11.18 14 10.59 13.41T10 12 10.59 10.59 12 10 13.41 10.59 14 12 13.41 13.41 12 14M18 14Q17.18 14 16.59 13.41T16 12 16.59 10.59 18 10 19.41 10.59 20 12 19.41 13.41 18 14"/>',
    },
  },
  animation: () => import("../animations/more.js"),
};

export default icon;
